import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getLabelList(labelName,pageNum,pageSize) {
  return request({
    url: '/pmsLabel/getLabelList',
    params: {
      labelName: labelName,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function updateLabel(label) {
  console.log(label);
  return requestMsg({
    url: '/pmsLabel/updateLabel',
    data: JSON.stringify(label),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}

export function getLabelById(id) {
  return requestMsg({
    url: '/pmsLabel/getLabelById',
    params: {
      id: id,
    }
  })
}

export function delByLabelId(id) {
  return requestMsg({
    url: '/pmsLabel/delByLabelId',
    params: {
      id: id,
    }
  })
}
